const BackgroundVideo = () => {
  return (
    <>
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src="/background/bg.webm"
        autoPlay
        loop
        muted
        playsInline
        ref={(video) => {
          if (video) video.playbackRate = 0.9;
        }}
      />

      <div className="absolute inset-0 bg-black/50"></div>
    </>
  );
};

export default BackgroundVideo;
